import { useState } from "react";
import { PropTypes } from "prop-types";
import { Paper, Chip, TextField } from "@mui/material";
import "./skills.scss";

const propTypes = {
  skills: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSkills: PropTypes.func.isRequired,
};

const Skills = ({ skills, setSkills }) => {
  const [newSkill, setNewSkill] = useState("");

  const handleEnterSkill = (e) => {
    e.preventDefault();
    if (newSkill === "") return;
    setSkills([...skills, newSkill]);
    setNewSkill("");
  };

  const handleDelete = (index) => {
    setSkills((skillsList) => skillsList.filter((_, i) => index !== i));
  };

  const listSkillChips = skills.map((skill, i) => {
    return (
      <li key={skill} className="skill-chip">
        <Chip label={skill} onDelete={() => handleDelete(i)} />
      </li>
    );
  });

  return (
    <Paper variant="outlined" className="skills-container">
      <ul className="skills-ul">{listSkillChips}</ul>
      <TextField
        className="skill-input"
        label="Add a new skill"
        variant="standard"
        value={newSkill}
        onChange={(e) => setNewSkill(e.target.value)}
        onBlur={(e) => handleEnterSkill(e)}
        onKeyDown={(e) => e.key === "Enter" && handleEnterSkill(e)}
      />
    </Paper>
  );
};

Skills.propTypes = propTypes;

export default Skills;
